export default __webpack_public_path__ + "bc0f5d4c8a38623c5ff03155485347e2.jpg";